import React, { useState } from 'react';
import axios from 'axios';
import '../styles/ChangePasswordModal.css';
import { API_BASE_URL } from '../utils/apiConfig';

const ChangePasswordModal = ({ isOpen, onClose, onSuccess }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirm password must match');
      return;
    }

    if (currentPassword === newPassword) {
      setError('New password must be different from current password');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API_BASE_URL}/auth/change-password`, {
        currentPassword,
        newPassword
      });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      const message = err.response?.data?.error || 'Failed to change password';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-overlay" onClick={onClose}>
      <div className="change-password-card" onClick={(event) => event.stopPropagation()}>
        <div className="change-password-header">
          <h3>Change Password</h3>
          <button type="button" className="change-password-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="change-password-body" onSubmit={handleSubmit}>
          <label className="change-password-label">
            Current Password
            <input
              type="password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              disabled={loading}
              autoComplete="current-password"
            />
          </label>
          <label className="change-password-label">
            New Password
            <input
              type="password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              disabled={loading}
              autoComplete="new-password"
            />
          </label>
          <label className="change-password-label">
            Confirm New Password
            <input
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              disabled={loading}
              autoComplete="new-password"
            />
          </label>

          {error && <div className="change-password-error">{error}</div>}

          <div className="change-password-actions">
            <button type="button" className="change-password-cancel" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="change-password-submit" disabled={loading}>
              {loading ? 'Saving...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
